<template>
    <li class="schedule-card" v-bind:class="{['variant-'+variant]: variant}" v-if="variant == 'without-card'">
        <div class="schedule-card-timeline">
            <div class="row">
                <div class="col text-left schedule-card-timeline-col"><slot name="schedule-card-content">De set staat klaar, laat het slachtoffer maar komen!</slot></div>
                <div class="col schedule-card-timeline-col"><slot name="schedule-card-end-date">17-04 / 17:00 AM</slot></div>
            </div>
        </div>
    </li>
    <li class="schedule-card" v-bind:class="{['variant-'+variant]: variant}" v-else>
        <div class="schedule-card-timeline">
            <div class="float-left"><slot name="schedule-card-start-date">07-04 / 09:00 AM</slot></div>
            <div class="float-right"><slot name="schedule-card-end-date">10-04 / 15:15 AM</slot></div>
        </div>
        <Card content-spacing="none">
            <div class="schedule-card-thumb">
                <div class="schedule-card-dates">

                </div>
            </div>
            <div class="schedule-card-text">
                <slot name="schedule-card-content"> De set staat klaar, laat het slachtoffer maar komen!</slot>
            </div>
            <div class="schedule-card-labels">
                <slot name="schedule-card-labels"><Label color="green">Work</Label><Label color="blue">Binding</Label></slot>
            </div>
            <div class="schedule-card-actions">
                <div class="float-left">
                    <Button variant="icon-wrap"><svgicon name="delete" height="1.2rem"></svgicon></Button>
                </div>
                <div class="float-right">
                    <Button variant="icon-wrap"><svgicon name="edit" height="1.2rem"></svgicon></Button>
                    <Button variant="icon-wrap"><svgicon name="view" height="1.2rem"></svgicon></Button>
                </div>
            </div>
        </Card>
    </li>
</template>
<script>
    import Card from "../../components/Card/Card";
    import Button from "../../components/Button/Button";
    import Label from "../../components/Label/Label";

    export default {
        name: 'ScheduleCard',
        components: {
            Card,
            Button,
            Label
        },
        props: {
            variant: {
                type: String,
                default: 'with-card'
            }
        },
        data () {
            return {

            }
        },
        computed: {

        },
        mounted () {

        },
        methods: {

        }
    }

</script>
<style src="./ScheduleCard.scss" scoped lang="scss"></style>

